import React from 'react';
import { FormattedText } from 'core/i18n';
import { showLegalInfoByCountry } from 'utilities/logicByCountry';

export const LegalInfoByCountry = ({ legalInfoByCountry, legalInfo }) => {
    const shouldShowLegalInfoByCountry = showLegalInfoByCountry() ? legalInfoByCountry : legalInfo;

    return Object.entries(shouldShowLegalInfoByCountry).map(([key, value]) => {
        return <FormattedText key={key} value={key} injectedStrings={value} />;
    });
};
